import { createBrowserHistory, History } from 'history';
import { BASE_URL } from '../constants/endpoints';

export const history: History = createBrowserHistory({ basename: BASE_URL });
